import { salesManagers } from '../data/salesManagers';
import type { Team } from '../types/voip';

/** Team color treatment, shared across every tab */
export const teamTone: Record<Team, string> = {
  Rivera: 'bg-team-a-soft text-team-a',
  Thompson: 'bg-team-b-soft text-team-b',
  Walsh: 'bg-team-c-soft text-team-c',
  Nguyen: 'bg-team-d-soft text-team-d',
  Park: 'bg-team-e-soft text-team-e',
};

export function teamLabel(team: Team): string {
  return salesManagers.find((m) => m.team === team)?.label ?? team;
}

export function managerName(team: Team): string {
  return salesManagers.find((m) => m.team === team)?.manager ?? team;
}
